import handleError from '@fuse/core/errorHandler';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'app/configs/api';
import axios from 'axios';
const initialState = {
  newAlarmsCount: 0,
  alarms: null,
  videoCallInfo: null,
  conferenceAlarms: null,
  loading: false,
};

export const getAlarmsList = createAsyncThunk('alarms/getAlarms', async (body) => {
  try {
    const response = await axios.post(API.getAlarmsList, body, {
      headers: {
        'Accept-Language': `${localStorage.getItem('language') === 'ru' ? 'ru' : 'uz'}`,
      },
    });
    return response.data;
  } catch (e) {
    handleError(e);
    return [];
  }
});

export const getConferenceAlarmsList = createAsyncThunk('alarms/getConferenceAlarms', async () => {
  try {
    const response = await axios.post(
      API.getAlarmsList,
      {
        filters: '{}',
        first: 1,
        rows: 20,
        sortField: 'id',
        sortOrder: 0,
      },
      {
        headers: {
          'Accept-Language': `${localStorage.getItem('language') === 'ru' ? 'ru' : 'uz'}`,
        },
      }
    );

    const filtered = response.data?.items?.filter(
      (el) => !el.alarmStatus && el.senderSystemId === 5
    );

    return { ...response.data, items: filtered };
  } catch (e) {
    handleError(e);
    return { items: [] };
  }
});

export const getNewAlarmsCount = createAsyncThunk('alarms/newAlarmsCount', async () => {
  try {
    const response = await axios.get(API.getNewAlarmsCount);
    return response.data;
  } catch (e) {
    handleError(e);
    return 0;
  }
});

export const setAlarmAsRead = createAsyncThunk('alarms/setAlarmAsRead', async (params) => {
  try {
    const response = await axios.post(API.updateAlarmStatus + `?alarmId=${params.id}`);
    if (response.data) {
      return params.id;
    } else {
      return null;
    }
  } catch (e) {
    handleError(e);
    return null;
  }
});

const alarmsSlice = createSlice({
  name: 'alarms',
  initialState,
  reducers: {
    increaseAlarmsCount: (state) => {
      state.newAlarmsCount += 1;
    },
    decreaseAlarmsCount: (state) => {
      if (state.newAlarmsCount > 0) {
        state.newAlarmsCount -= 1;
      } else {
        state.newAlarmsCount = 0;
      }
    },
    readAll: (state) => {
      state.newAlarmsCount = 0;
      state.alarms = {
        ...state.alarms,
        items: state.alarms.items.map((item) => ({ ...item, alarmStatus: 1 })),
      };
    },
    setVideoCallInfo: (state, action) => {
      state.videoCallInfo = action.payload;
    },
  },
  extraReducers: {
    [getAlarmsList.fulfilled]: (state, action) => {
      state.alarms = action.payload;
      state.loading = false;
    },
    [getAlarmsList.pending]: (state, action) => {
      state.loading = true;
    },
    [getAlarmsList.rejected]: (state, action) => {
      state.loading = false;
      state.alarms = null;
    },
    [getNewAlarmsCount.fulfilled]: (state, action) => {
      state.newAlarmsCount = action.payload;
    },
    [setAlarmAsRead.fulfilled]: (state, action) => {
      if (action.payload) {
        const index = state.alarms?.items.findIndex((alarm) => alarm.id === action.payload);
        if (index > -1) {
          state.alarms.items[index].alarmStatus = 1;
        }
      }
    },
    [getConferenceAlarmsList.fulfilled]: (state, action) => {
      state.conferenceAlarms = action.payload;
    },
    [getConferenceAlarmsList.rejected]: (state, action) => {
      state.conferenceAlarms = null;
    },
  },
});

export const { increaseAlarmsCount, decreaseAlarmsCount, setVideoCallInfo, readAll } =
  alarmsSlice.actions;

export const selectNewAlarmsCount = ({ alarms }) => alarms.newAlarmsCount;

export const selectAlarms = ({ alarms }) => alarms.alarms;

export const selectVideoCallInfo = ({ alarms }) => alarms.videoCallInfo;

export const selectConferenceAlarms = ({ alarms }) => alarms.conferenceAlarms?.items;

export default alarmsSlice.reducer;
